import { DeliveryFilterModel } from "./DeliveryFilter.model";

export class DeliveryFilter extends DeliveryFilterModel {
    // Add custom methods here
}
